export const PAGE_TYPES = [
  'kuran',
  'cevsen',
  'celcelutiye',
  'evrad-i-kudsiye',
  'sabah-dualari',
  'aksam-dualari',
  'tahmidiye-duasi',
  'cevsen-i-serif',
  'ashab-i-bedir',
  'ashab-i-uhud',
  'sekine-duasi',
  'peygamber-efendimizin-dualari',
  'ismi-azam-duasi',
  'tercumani-ismi-azam-duasi',
  'veysel-karani-munacati',
  'delailul-nur',
  'kumeyl-duasi',
  'hulasatul-hulasa',
  'munacatul-kuran-duasi',
  'aksam-namazi-tesbihati',
  'yatsi-namazi-tesbihati',
  'ogle-namazi-tesbihati',
  'ikindi-namazi-tesbihati',
  'sabah-namazi-tesbihati',
  'kurandan-rabbena-dualari',
  'namaz-dualari',
  'salli-barik-duasi',
  'suheda-i-uhud-duasi',
  'rabbena-duasi',
  'esmaul-husna',
  'hizbun-nasr-duasi',
  'imam-sazeli-hizbun-nasr-duasi',
  'sizden-gelen-dualar',
  'hacet-ve-ferahlik-munacati',
  'hacetleri-allahtan-isteme-duasi',
  'korunma-duasi',
] as const

export type PageType = (typeof PAGE_TYPES)[number]

export const DEFAULT_VISIBLE_PAGES: PageType[] = [
  'kuran',
  'cevsen',
  'aksam-dualari',
  'sabah-dualari',
]

export type AdditionalStatsType = 'kazaNamazi' | 'nafileNamaz' | 'oruc' | 'teheccudNamazi'

export type LoggableContentType = PageType | AdditionalStatsType
